"use client";

import { Badge } from "@repo/ui/controls";
import { useI18n } from "@repo/ui/providers";
import type { ComponentProps } from "react";
import type { StatsStatus } from "@/lib/stats-types";

const VARIANT: Record<StatsStatus, ComponentProps<typeof Badge>["variant"]> = {
  supported: "default",
  in_progress: "secondary",
  watching: "outline",
  requested: "outline",
  pending: "outline",
  declined: "outline",
};

/** Dict key of each status name (STATUS_LABELS stays English for the admin editor). */
export const STATUS_KEYS: Record<StatsStatus, string> = {
  supported: "www.stats.status.supported",
  in_progress: "www.stats.status.inProgress",
  watching: "www.stats.status.watching",
  requested: "www.stats.status.requested",
  pending: "www.stats.status.pending",
  declined: "www.stats.status.declined",
};

export function StatusBadge({ status }: { status: StatsStatus }) {
  const { t } = useI18n();
  return (
    <Badge variant={VARIANT[status]} className="whitespace-nowrap">
      {t(STATUS_KEYS[status])}
    </Badge>
  );
}
